<template>
    <v-card-component :title="cardTitle" :icon="cardIcon">
<v-row>
  <v-col>
          <v-row>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Address <span class="error--text ml-1" v-if="isEnquiry===false">*</span></span>
          <!--  -->
          <v-text-field type="text" placeholder="Address" v-model.trim="value.address"
            class="my-0 py-1" :readonly="isReadonly" :disabled="isDisabled" single-line :required="isEnquiry===false ? true:false">
          </v-text-field>
        </v-col>

        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">PIN Code <span class="error--text ml-1" v-if="isEnquiry===false">*</span></span>
          <v-text-field placeholder="Pincode" type="number"
            onKeyPress="if(this.value.length==6) return false;" v-model="value.pincode"
            :readonly="isReadonly" :disabled="isDisabled" class="my-0 py-1"
            single-line :required="isEnquiry===false ? true:false">
          </v-text-field>
        </v-col>

        <v-col cols="12" lg="4" sm="6" v-if="formType !== 'createEnquiryQR'">
          <span class="body-2 font-weight-medium">Country</span>
          <span class="error--text ml-1" v-if="isEnquiry===false">*</span>
          <v-text-field placeholder="Country" type="text" v-model="value.countryName" readonly
            disabled class="my-0 py-1" single-line >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">State</span>
          <span class="error--text ml-1" v-if="isEnquiry===false">*</span>
          <v-autocomplete class="my-0 py-1" single-line v-model="value.state"
            :readonly="isReadonly" :disabled="isDisabled" placeholder="---Select---"
            :items="states" key="name" item-text="name" item-value="name" :required="isEnquiry===false ? true:false">
          </v-autocomplete>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">City</span>
          <span class="error--text ml-1" v-if="isEnquiry===false">*</span>
          <v-text-field type="text" placeholder="City" v-model.trim="value.city" class="my-0 py-1"
            :readonly="isReadonly" :disabled="isDisabled" single-line :required="isEnquiry===false ? true:false"> </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Locality</span>
          <v-text-field type="text" placeholder="Location" v-model.trim="value.locality"
            class="my-0 py-1" :readonly="isReadonly" :disabled="isDisabled" single-line>
          </v-text-field>
        </v-col>

        <v-col cols="12" lg="4" sm="6" v-if="formType === 'studEdit'">
          <span class="body-2 font-weight-medium">Parent's Locality</span>
          <v-text-field type="text" placeholder="Location" v-model="value.paLocality"
            class="my-0 py-1" :readonly="isReadonly" :disabled="isDisabled" single-line>
          </v-text-field>
        </v-col>
      </v-row>
  </v-col>
</v-row>
    </v-card-component>
</template>
<style scoped>
.card-header-title {
  color: error !important;
}
</style>
<script>
// import Utils from '@/utils'
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent },
  name: 'AddressElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  data: function () {
    return {
      loadingComponent: null,
      isWrite: false,
      isEnquiry: false,
      cardTitle: '',
      cardIcon: '',
      states: [{}],
      country: [{ text: 'India', value: 'India' }],
      isAdmission: false,
      isReadonly: false,
      isDisabled: false
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },
  async created () {
    await this.onStart()
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }

    if (this.formType === 'enquiry') {
      this.isEnquiry = true
    }
  },
  methods: {
    onStart: async function () {
      try {
        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.states = stateresponse.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }

      if (this.formType === 'applicationForm') {
        this.cardTitle = 'Address Details ( Please enter a valid delivery address )'
        this.cardIcon = 'mdi-home-map-marker'
      } else if (this.formType !== 'admission') {
        this.cardTitle = 'Address Details'
        this.cardIcon = 'mdi-home-map-marker'
      } else {
        this.cardTitle = 'Current Address'
        this.isAdmission = true
      }
    }
  }
}
</script>
